import api from './api';

const buildQuery = (startDate, endDate) =>
  startDate && endDate ? `?startDate=${startDate}&endDate=${endDate}` : '';

const reportService = {
  getSummary: async (startDate, endDate) => {
    const res = await api.get(`/reports/summary${buildQuery(startDate, endDate)}`);
    return res.data;
  },
  getMonthlySales: async (startDate, endDate) => {
    const res = await api.get(`/reports/monthly-sales${buildQuery(startDate, endDate)}`);
    return res.data;
  },
  getTopCustomers: async (startDate, endDate) => {
    const res = await api.get(`/reports/top-customers${buildQuery(startDate, endDate)}`);
    return res.data;
  },
  getFinancialSummary: async (startDate, endDate) => {
    const res = await api.get(`/reports/financial${buildQuery(startDate, endDate)}`);
    return res.data;
  },
  getStockReport: async () => {
    const res = await api.get('/reports/stock');
    return res.data;
  },
  getTopProducts: async (startDate, endDate) => {
    const res = await api.get(`/reports/top-products${buildQuery(startDate, endDate)}`);
    return res.data;
  },
};

export default reportService;
